import { useEffect, useState } from "react"
import { marketplaceApi } from "../infrastructure/marketplace.api"
import type { PluginInstallDto } from "../dtos/marketplace.dto"

interface ActivePlugins {
  installs: PluginInstallDto[]
  // Distinct familyIds of the org's active installs — used to drive plugin nav.
  activeFamilies: string[]
  isLoading: boolean
}

// Loads the org's plugin installs and exposes which families are currently
// active. Drives the marketplace-plugin nav items and per-plugin page guards.
export function useActivePlugins(organizationId: string | null | undefined): ActivePlugins {
  const [installs, setInstalls] = useState<PluginInstallDto[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!organizationId) {
      setInstalls([])
      return
    }

    let cancelled = false
    setIsLoading(true)

    marketplaceApi
      .listInstalls(organizationId)
      .then((data) => {
        if (!cancelled) setInstalls(data)
      })
      .catch(() => {
        if (!cancelled) setInstalls([])
      })
      .finally(() => {
        if (!cancelled) setIsLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [organizationId])

  const activeFamilies = [
    ...new Set(
      installs
        .filter((i) => i.status === "Active" && i.familyId)
        .map((i) => i.familyId as string),
    ),
  ]

  return { installs, activeFamilies, isLoading }
}
